import { request } from '../http';

export type VehicleCatalogOption = {
  id: string;
  name: string;
  slug: string;
};

export const vehicleCatalogService = {
  makes: (q?: string) =>
    request<VehicleCatalogOption[]>(
      `/vehicle-catalog/makes${q ? `?q=${encodeURIComponent(q)}` : ''}`,
    ),
  models: (makeId?: string, q?: string) => {
    const params = new URLSearchParams();
    if (makeId) params.set('make_id', makeId);
    if (q) params.set('q', q);
    const qs = params.toString();
    return request<VehicleCatalogOption[]>(`/vehicle-catalog/models${qs ? `?${qs}` : ''}`);
  },
  trims: (modelId?: string, q?: string) => {
    const params = new URLSearchParams();
    if (modelId) params.set('model_id', modelId);
    if (q) params.set('q', q);
    const qs = params.toString();
    return request<VehicleCatalogOption[]>(`/vehicle-catalog/trims${qs ? `?${qs}` : ''}`);
  },
};
